module.exports = __webpack_public_path__ + "static/img/top-img-main.dda41c1.jpg";